import { Database, Network, Boxes, Siren, ShieldCheck, GitBranch, FileCode } from "lucide-react";

export const SEVERITY_META = {
  P1: { label: "P1 Critical", badge: "bg-red-500/10 text-red-500 dark:text-red-300 border-red-500/30", dot: "bg-red-500" },
  P2: { label: "P2 High", badge: "bg-amber-500/10 text-amber-600 dark:text-amber-300 border-amber-500/30", dot: "bg-amber-500" },
  P3: { label: "P3 Medium", badge: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-300 border-indigo-500/30", dot: "bg-indigo-500" },
  P4: { label: "P4 Low", badge: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-300 border-emerald-500/30", dot: "bg-emerald-500" },
};

export const CATEGORY_META = {
  Database: { icon: Database },
  Networking: { icon: Network },
  Kubernetes: { icon: Boxes },
  "Incident Management": { icon: Siren },
  Security: { icon: ShieldCheck },
  "CI/CD": { icon: GitBranch },
};

export const OUTCOME_META = {
  success: { label: "Success", cls: "text-emerald-500", badge: "bg-emerald-500/10 text-emerald-500 border-emerald-500/30" },
  failed: { label: "Failed", cls: "text-red-500", badge: "bg-red-500/10 text-red-500 border-red-500/30" },
  escalated: { label: "Escalated", cls: "text-amber-500", badge: "bg-amber-500/10 text-amber-500 border-amber-500/30" },
};

export function categoryIcon(cat) {
  return (CATEGORY_META[cat] && CATEGORY_META[cat].icon) || FileCode;
}
